import { call } from '@spacefill/shared/src/utils/Backend';

const AppointmentsProviderView = async () =>
    import('../../pages/appointments/AppointmentsProviderView').then((module) => ({
        Component: module.AppointmentsProviderView,
    }));

const AppointmentsShipperView = async () =>
    import('../../pages/appointments/AppointmentsShipperView').then((module) => ({
        Component: module.AppointmentsShipperView,
    }));

const AppointmentOrderModal = async () =>
    import('../../pages/logistic-management/orders/view/AppointmentModal/AppointmentOrderModal').then((module) => ({
        Component: module.AppointmentOrderModal,
    }));
const AppointmentModal = async () =>
    import('../../pages/logistic-management/orders/view/AppointmentModal/AppointmentModal').then((module) => ({
        Component: module.AppointmentModal,
    }));

const editAppointmentFromOrderIdLoader = async ({ params: { orderId, appointmentId } }) => {
    const order = await call(`orders/${orderId}`);
    return {
        order,
        appointment: order.transport?.appointments?.find((appointment) => appointment.id === appointmentId),
        edit: true,
    };
};

const editAppointmentFromAppointmentIdLoader = async ({ params: { appointmentId } }) => {
    const appointment = await call(`appointments/${appointmentId}`);
    return { appointment, edit: true };
};

const getAppointmentsRoutes = (user) => {
    const shipperCanShowAppointments =
        user.role === 'SHIPPER' && user.logisticProviders.some((lsp) => lsp.settings?.appointmentScheduling?.enabled);

    const providerCanShowAppointments =
        user.role === 'PROVIDER' && user.logisticProvider?.settings?.appointmentScheduling?.enabled;
    const lspAppointmentsRoutes = [
        //  Appoinltments
        {
            path: '/appointments/',
            lazy: AppointmentsProviderView,
            children: [
                {
                    path: 'edit/order/:orderId/:appointmentId',
                    lazy: AppointmentOrderModal,
                    loader: editAppointmentFromOrderIdLoader,
                },
                {
                    path: 'edit/appointment/:appointmentId',
                    lazy: AppointmentModal,
                    loader: editAppointmentFromAppointmentIdLoader,
                },
            ],
        },
        {
            path: '/appointments/calendar',
            lazy: AppointmentsProviderView,
        },
        {
            path: '/appointments/warehouses/:warehouseId/calendar',
            lazy: AppointmentsProviderView,
        },
        {
            path: '/appointments/list',
            lazy: AppointmentsProviderView,
        },
        {
            path: '/appointments/list/view/:viewId',
            lazy: AppointmentsProviderView,
        },
        {
            path: '/appointments/warehouses/:warehouseId/list',
            lazy: AppointmentsProviderView,
        },
        {
            path: '/appointments/warehouses/:warehouseId/list/view/:viewId',
            lazy: AppointmentsProviderView,
        },
    ];
    const shipperAppointmentsRoutes = [
        {
            path: '/appointments/list',
            lazy: AppointmentsShipperView,
        },
        {
            path: '/appointments/warehouses/:warehouseId/list',
            lazy: AppointmentsShipperView,
        },
    ];
    if (providerCanShowAppointments) {
        return lspAppointmentsRoutes;
    } else if (shipperCanShowAppointments) {
        return shipperAppointmentsRoutes;
    }

    return [];
};

export { getAppointmentsRoutes };
